import Axios 	from 	'axios';
import Config 	from 	'../config';
const uuidv4 = require('uuid/v4');
const { detect } = require('detect-browser');
const browser = detect();

class ApiRequest
{
	/**
	 * Send HTTP request (get or post).
	 *
	 * @param 	{string} 	method 	get|post
	 * @param 	{Object}	data 	JSON formatted data to be the body of the request
	 * @param 	{string}	path 	Route path for backend API
	 *
	 * @return 	{Promise}	A promise containing the result of the request
	 */
	static async sendRequest(method, params, path, token = "", contentType = 'application/json')
	{
		try
		{
			// Session ID
			var uuid = localStorage.getItem('uuid');
			if(uuid === null)
			{
					uuid = uuidv4();
					localStorage.setItem('uuid', uuid);
			}

			let config =
			{
				method: 	method,
				url:		Config.API_SERVER_URL + path,
				headers:
				{
					'Content-Type': contentType,
					'x-access-token': token,
					'x-device-id': 	uuid,
					'x-request-source': 'web',
					'x-device-service-name': browser.name,
					'x-device-service-version': browser.version
				},
				data:		params
			};

			const response = await Axios.request(config);
			return response;
		}
		catch(err)
		{
			console.error(err);
			throw err;
		}
	}

	/**
	 * Send HTTP request (get or post).
	 *
	 * @param 	{string} 	method 	get|post
	 * @param 	{Object}	data 	JSON formatted data to be the body of the request
	 * @param 	{string}	path 	Route path for backend API
	 *
	 * @return 	{Promise}	A promise containing the result of the request
	 */
	 static async sendExternalRequest({ url, method, params, path, token = "", contentType = 'application/json' })
	 {
		 try
		 {
			 // Session ID
			 var uuid = localStorage.getItem('uuid');
			 if(uuid === null)
			 {
					 uuid = uuidv4();
					 localStorage.setItem('uuid', uuid);
			 }
 
			 let config =
			 {
				 method: 	method,
				 url:		url + path,
				 headers:
				 {
					 'Content-Type': contentType,
					 'x-access-token': token,
					 'x-device-id': 	uuid,
					 'x-request-source': 'web',
					 'x-device-service-name': browser.name,
					 'x-device-service-version': browser.version
				 },
				 data:		params,
				 timeout: 1000 * 60, // Wait for 60 seconds
			 };
 
			 const response = await Axios.request(config);
			 return response;
		 }
		 catch(err)
		 {
			 console.error(err);
			 throw err;
		 }
	 }
}


export default ApiRequest;
